"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDomServer = require("react-dom/server");
var logo_svg_1 = require("svgs/brand/logo.svg");
var logo_light_svg_1 = require("svgs/brand/logo-light.svg");
var small_logo_svg_1 = require("svgs/brand/small-logo.svg");
var add_svg_1 = require("svgs/icon/add.svg");
var arrow_right_svg_1 = require("svgs/icon/arrow-right.svg");
var arrow_left_svg_1 = require("svgs/icon/arrow-left.svg");
var arrow_up_svg_1 = require("svgs/icon/arrow-up.svg");
var basket_svg_1 = require("svgs/icon/basket.svg");
var cancel_svg_1 = require("svgs/icon/cancel.svg");
var check_svg_1 = require("svgs/icon/check.svg");
var check_circled_svg_1 = require("svgs/icon/check-circled.svg");
var chevron_down_svg_1 = require("svgs/icon/chevron-down.svg");
var left_svg_1 = require("svgs/icon/left.svg");
var chevron_right_svg_1 = require("svgs/icon/chevron-right.svg");
var chevron_up_svg_1 = require("svgs/icon/chevron-up.svg");
var clear_svg_1 = require("svgs/icon/clear.svg");
var cross_svg_1 = require("svgs/icon/cross.svg");
var edit_svg_1 = require("svgs/icon/edit.svg");
var filter_svg_1 = require("svgs/icon/filter.svg");
var flex_svg_1 = require("svgs/icon/flex.svg");
var info_svg_1 = require("svgs/icon/info.svg");
var location_svg_1 = require("svgs/icon/location.svg");
var mail_svg_1 = require("svgs/icon/mail.svg");
var menu_svg_1 = require("svgs/icon/menu.svg");
var minus_svg_1 = require("svgs/icon/minus.svg");
var phone_svg_1 = require("svgs/icon/phone.svg");
var play_svg_1 = require("svgs/icon/play.svg");
var plus_svg_1 = require("svgs/icon/plus.svg");
var search_svg_1 = require("svgs/icon/search.svg");
var user_svg_1 = require("svgs/icon/user.svg");
var contact_svg_1 = require("svgs/icon/contact.svg");
var wishlist_svg_1 = require("svgs/icon/wishlist.svg");
var wishlist_active_svg_1 = require("svgs/icon/wishlist-active.svg");
var zoom_svg_1 = require("svgs/icon/zoom.svg");
var store_svg_1 = require("svgs/icon/store.svg");
var shipping_svg_1 = require("svgs/icon/shipping.svg");
var star_svg_1 = require("svgs/icon/star.svg");
var star_active_svg_1 = require("svgs/icon/star-active.svg");
var pin_svg_1 = require("svgs/icon/pin.svg");
var clock_svg_1 = require("svgs/icon/clock.svg");
var shopping_bag_svg_1 = require("svgs/icon/shopping-bag.svg");
var radio_active_svg_1 = require("svgs/icon/radio-active.svg");
var radio_inactive_svg_1 = require("svgs/icon/radio-inactive.svg");
var payment_afterpay_colour_svg_1 = require("svgs/payments/payment-afterpay-colour.svg");
var payment_afterpay_colour_svg_2 = require("svgs/payments/payment-afterpay-colour.svg");
var payment_master_svg_1 = require("svgs/payments/payment-master.svg");
var payment_paypal_svg_1 = require("svgs/payments/payment-paypal.svg");
var payment_visa_svg_1 = require("svgs/payments/payment-visa.svg");
var facebook_svg_1 = require("svgs/social/facebook.svg");
var instagram_svg_1 = require("svgs/social/instagram.svg");
var linkedin_svg_1 = require("svgs/social/linkedin.svg");
var pinterest_svg_1 = require("svgs/social/pinterest.svg");
var twitter_svg_1 = require("svgs/social/twitter.svg");
var youtube_svg_1 = require("svgs/social/youtube.svg");
var bell_svg_1 = require("svgs/icon/bell.svg");
var guernsey_svg_1 = require("svgs/icon/guernsey.svg");
var logout_svg_1 = require("svgs/icon/logout.svg");
var close_svg_1 = require("svgs/icon/close.svg");
var active_svg_1 = require("svgs/icon/active.svg");
var inactive_svg_1 = require("svgs/icon/inactive.svg");
var eye_svg_1 = require("svgs/icon/eye.svg");
var noeye_svg_1 = require("svgs/icon/noeye.svg");
var green_rounded_checkbox_svg_1 = require("svgs/icon/green-rounded-checkbox.svg");
var Svg = /** @class */ (function (_super) {
    __extends(Svg, _super);
    function Svg() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.className = "svg-" + _this.props.name + " " + _this.props.className;
        return _this;
    }
    Svg.toString = function (props) {
        var icon = Svg.items[props.name];
        return ReactDomServer.renderToString(React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: icon.viewBox, width: props.width, height: props.height, className: props.className, title: props.title },
            React.createElement("g", { dangerouslySetInnerHTML: { __html: icon.render().innerHTML } })));
    };
    Svg.prototype.render = function () {
        var icon = Svg.items[this.props.name];
        return icon ? (React.createElement("svg", { viewBox: icon.viewBox, width: this.props.width, height: this.props.height, className: this.props.className, title: this.props.title },
            React.createElement("use", { xlinkHref: "#" + icon.id, id: this.props.id }))) : (React.createElement("span", null));
    };
    Svg.items = {
        logo: logo_svg_1.default,
        "logo-light": logo_light_svg_1.default,
        "small-logo": small_logo_svg_1.default,
        user: user_svg_1.default,
        contact: contact_svg_1.default,
        add: add_svg_1.default,
        "arrow-right": arrow_right_svg_1.default,
        "arrow-left": arrow_left_svg_1.default,
        "arrow-up": arrow_up_svg_1.default,
        basket: basket_svg_1.default,
        bag: shopping_bag_svg_1.default,
        cancel: cancel_svg_1.default,
        check: check_svg_1.default,
        "check-circled": check_circled_svg_1.default,
        "chevron-down": chevron_down_svg_1.default,
        "chevron-left": left_svg_1.default,
        "chevron-right": chevron_right_svg_1.default,
        "chevron-up": chevron_up_svg_1.default,
        clear: clear_svg_1.default,
        cross: cross_svg_1.default,
        edit: edit_svg_1.default,
        filter: filter_svg_1.default,
        flex: flex_svg_1.default,
        info: info_svg_1.default,
        location: location_svg_1.default,
        mail: mail_svg_1.default,
        menu: menu_svg_1.default,
        minus: minus_svg_1.default,
        phone: phone_svg_1.default,
        plus: plus_svg_1.default,
        play: play_svg_1.default,
        search: search_svg_1.default,
        star: star_svg_1.default,
        "star-active": star_active_svg_1.default,
        wishlist: wishlist_svg_1.default,
        "wishlist-active": wishlist_active_svg_1.default,
        zoom: zoom_svg_1.default,
        store: store_svg_1.default,
        shipping: shipping_svg_1.default,
        pin: pin_svg_1.default,
        clock: clock_svg_1.default,
        "radio-active": radio_active_svg_1.default,
        "radio-inactive": radio_inactive_svg_1.default,
        "payment-afterpay": payment_afterpay_colour_svg_1.default,
        "payment-afterpay-colour": payment_afterpay_colour_svg_2.default,
        "payment-master": payment_master_svg_1.default,
        "payment-paypal": payment_paypal_svg_1.default,
        "payment-visa": payment_visa_svg_1.default,
        facebook: facebook_svg_1.default,
        instagram: instagram_svg_1.default,
        linkedin: linkedin_svg_1.default,
        pinterest: pinterest_svg_1.default,
        twitter: twitter_svg_1.default,
        youtube: youtube_svg_1.default,
        bell: bell_svg_1.default,
        guernsey: guernsey_svg_1.default,
        logout: logout_svg_1.default,
        close: close_svg_1.default,
        active: active_svg_1.default,
        inactive: inactive_svg_1.default,
        eye: eye_svg_1.default,
        noeye: noeye_svg_1.default,
        "green-rounded-checkbox": green_rounded_checkbox_svg_1.default
    };
    return Svg;
}(React.PureComponent));
exports.Svg = Svg;
